/**
 * Belcopia Upgrade Selectors
 * Renders dropdown upgrade options above Add to Cart.
 * Intercepts form submit to add main product + upgrades together.
 * Works with Impulse v5.x theme (product-template snippet).
 */
(function () {
  'use strict';

  var container = document.getElementById('BelcopiaUpgrades');
  if (!container) return;

  // ── Reposition into product form area ────────────────────────────────
  // Impulse renders blocks inside [data-product-blocks].
  // The buy_buttons block contains the product form.
  // Insert upgrade container right before the buy_buttons block.
  var productForm = document.querySelector('.product-single__form');
  if (!productForm) {
    productForm = document.querySelector('form[action*="/cart/add"]');
  }

  if (productForm) {
    // Walk up to find the .product-block wrapper of the buy_buttons block.
    // Insert the configurator/kit AFTER it (below Add to Cart) — Amazon-style: the
    // primary CTA stays reachable; the upsell comes right after the buy decision.
    var buyBlock = productForm.closest('.product-block');
    if (buyBlock && buyBlock.parentElement) {
      buyBlock.parentElement.insertBefore(container, buyBlock.nextSibling);
    }
  }

  // Show container now that it's positioned correctly
  container.style.display = '';

  // ── Subtotal calculation ─────────────────────────────────────────────
  var selects = container.querySelectorAll('[data-upgrade-select]');
  var subtotalEl = document.getElementById('BelcopiaUpgradeSubtotal');
  var totalEl = document.getElementById('BelcopiaUpgradeTotal');

  // Items toggled "into the build" — variantId -> priceCents (bundled into Add to Cart).
  var gearSelected = {};
  // variantId -> short label, for the "In your build" recap.
  var gearTitles = {};
  var swapIds = {};            // variant ids that are upgrade PARTS (ship as separate add-ons)
  var buildListEl = container.querySelector('[data-bc-build-list]');
  var partNoteEl = container.querySelector('[data-bc-part-note]');

  // Toggle a card's visual "in your build" state in one place: button label +
  // the card border indicator (.bcg-card--selected). ab = the card's +Add button.
  function setGearCardState(ab, on) {
    if (!ab) return;
    ab.classList.toggle('bcg-card__add--done', on);
    ab.textContent = on ? 'Added ✓' : '+ Add';
    var card = ab.closest('.bcg-card');
    if (card) card.classList.toggle('bcg-card--selected', on);
  }

  function updateSubtotal() {
    var total = 0;
    selects.forEach(function (sel) {
      var opt = sel.options[sel.selectedIndex];
      var priceCents = parseInt(opt.getAttribute('data-price') || '0', 10);
      if (!isNaN(priceCents)) total += priceCents;
    });
    var names = [];
    Object.keys(gearSelected).forEach(function (id) {
      var c = parseInt(gearSelected[id] || '0', 10);
      if (!isNaN(c)) total += c;
      if (gearTitles[id]) names.push(gearTitles[id]);
    });
    if (total > 0) {
      subtotalEl.style.display = '';
      totalEl.textContent = '+$' + (total / 100).toFixed(2);
    } else {
      subtotalEl.style.display = 'none';
    }
    if (buildListEl) {
      if (names.length) {
        buildListEl.style.display = '';
        buildListEl.innerHTML = 'In your build: <strong>' + names.join('</strong>, <strong>') + '</strong>';
      } else {
        buildListEl.style.display = 'none';
      }
    }
    if (partNoteEl) {
      var hasPart = Object.keys(gearSelected).some(function (id) { return swapIds[id]; });
      partNoteEl.style.display = hasPart ? '' : 'none';
    }
  }

  // ── Category notes (show/hide on selection) ────────────────────────
  var crankNote = container.querySelector('[data-crank-note]');

  function updateNotes() {
    if (crankNote) {
      var sel = crankNote.closest('.belcopia-upgrades__select-wrap')
        .querySelector('[data-upgrade-select]');
      crankNote.style.display = sel && sel.value ? '' : 'none';
    }
  }

  function updatePreviews() {
    selects.forEach(function (sel) {
      var opt = sel.options[sel.selectedIndex];
      var row = sel.closest('.belcopia-upgrades__row');
      if (!row) return;
      var link = row.querySelector('[data-upgrade-preview-link]');
      var img = row.querySelector('[data-upgrade-preview]');
      if (!img) return;
      var src = opt.getAttribute('data-image');
      var url = opt.getAttribute('data-url');
      if (sel.value && src) {
        img.src = src;
        img.alt = opt.getAttribute('data-title') || '';
        img.classList.add('is-visible');
        img.style.display = 'block';
        if (link) {
          link.href = url || '#';
          link.style.display = url ? 'inline-flex' : 'none';
        }
      } else {
        img.classList.remove('is-visible');
        img.style.display = 'none';
        img.src = '';
        if (link) {
          link.style.display = 'none';
          link.href = '#';
        }
      }
    });
  }

  selects.forEach(function (sel) {
    sel.addEventListener('change', function () {
      updateSubtotal();
      updateNotes();
      updatePreviews();
    });
  });

  // ── Intercept Add to Cart ────────────────────────────────────────────
  if (!productForm) return;

  // Get the product title for the _upgrade_for property
  // We target H1 specifically and use .innerText to avoid grabbing hidden <script> content
  var productTitleEl = document.querySelector(
    'h1.product-single__title, h1.product__title, h1[data-product-title], .product-single__title h1'
  );
  if (!productTitleEl) {
    productTitleEl = document.querySelector('.product-single__title, h1.product__title, [data-product-title]');
  }
  var productTitle = productTitleEl ? (productTitleEl.innerText || productTitleEl.textContent).split('\n')[0].trim() : '';

  productForm.addEventListener(
    'submit',
    function (e) {
      // Collect selected upgrades
      var upgradeItems = [];
      selects.forEach(function (sel) {
        var val = sel.value;
        if (val) {
          upgradeItems.push({
            id: parseInt(val, 10),
            quantity: 1,
            properties: { _upgrade_for: productTitle }
          });
        }
      });

      // Add any gear toggled into the build
      Object.keys(gearSelected).forEach(function (id) {
        upgradeItems.push({
          id: parseInt(id, 10),
          quantity: 1,
          properties: { _upgrade_for: productTitle }
        });
      });

      // If nothing extra selected, let form submit normally
      if (upgradeItems.length === 0) return;

      // Prevent default and stop theme handler
      e.preventDefault();
      e.stopImmediatePropagation();

      // Get main product variant ID
      var mainVariantInput = productForm.querySelector(
        'select[name="id"], input[name="id"]'
      );
      var mainVariantId = mainVariantInput ? mainVariantInput.value : null;
      if (!mainVariantId) return;

      // Get quantity
      var qtyInput = productForm.querySelector(
        'input[name="quantity"], select[name="quantity"]'
      );
      var mainQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      // Build items array: main product + upgrades
      var items = [{ id: parseInt(mainVariantId, 10), quantity: mainQty }];
      items = items.concat(upgradeItems);

      // Disable submit button
      var submitBtn = productForm.querySelector('[data-add-to-cart]');
      var originalHTML = '';
      if (submitBtn) {
        originalHTML = submitBtn.innerHTML;
        submitBtn.disabled = true;
        submitBtn.innerHTML =
          '<span data-add-to-cart-text>Adding...</span>';
      }

      // POST multi-item add
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Cart add HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          // Success feedback
          if (submitBtn) {
            submitBtn.innerHTML =
              '<span data-add-to-cart-text>Added!</span>';
            setTimeout(function () {
              submitBtn.innerHTML = originalHTML;
              submitBtn.disabled = false;
            }, 2000);
          }

          // Trigger Impulse cart drawer (ajaxProduct:added event)
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: data }
            })
          );

          // Reset dropdowns
          selects.forEach(function (sel) {
            sel.selectedIndex = 0;
          });
          // Reset gear selections
          gearSelected = {};
          container.querySelectorAll('.bcg-card__add--done').forEach(function (b) {
            setGearCardState(b, false);
          });
          var bb = container.querySelector('.bcg-bundle__btn--done');
          if (bb) { bb.classList.remove('bcg-bundle__btn--done'); bb.textContent = 'Add all'; }
          var kb = container.querySelector('.bc-kit__btn--done');
          if (kb) { kb.classList.remove('bc-kit__btn--done'); kb.textContent = 'Add the Kit'; }
          container.querySelectorAll('.bc-kitcard--selected').forEach(function (c) {
            c.classList.remove('bc-kitcard--selected');
            var a = c.querySelector('.bc-kitcard__add'); if (a) a.textContent = 'Add Kit';
          });
          updateSubtotal();
          updatePreviews();
        })
        .catch(function (err) {
          console.error('[Belcopia Upgrades] Add failed:', err);
          if (submitBtn) {
            submitBtn.innerHTML = originalHTML;
            submitBtn.disabled = false;
          }
        });
    },
    true // capture phase — run before theme handler
  );

  // ── Unified build grid: swaps + accessories as cards ─────────────────
  // Swap items come from .bc-swap-data (custom.build_upgrades, single-select per
  // type), accessories from the .bc-cu-data block the upsell section already
  // emits (multi-add) — so ZERO extra all_products lookups. Everything toggles
  // into gearSelected → counted in the Build total → bundled into Add to Cart.

  // One shared category vocabulary for the chips (mirrors belcopia-cart-upsell.js)
  function gearCategoryOf(s) {
    s = (s || '').toLowerCase();
    if (/helmet/.test(s)) return 'Helmets';
    if (/lock/.test(s)) return 'Locks & Security';
    if (/light|mirror|reflector|bell|airtag/.test(s)) return 'Lights & Visibility';
    if (/saddle|seat-?post/.test(s)) return 'Saddles & Seating';
    if (/fork|suspension/.test(s)) return 'Suspension';
    if (/torque|sensor/.test(s)) return 'Performance';
    if (/child|trailer|pet|cushion/.test(s)) return 'Family & Cargo';
    if (/basket|frame.?bag|frame storage|handrail|rack|fender|pannier|fanny|storage|bag/.test(s)) return 'Storage & Racks';
    return 'More';
  }
  var GEAR_CAT_ORDER = ['Saddles & Seating', 'Suspension', 'Performance', 'Lights & Visibility', 'Storage & Racks', 'Locks & Security', 'Helmets', 'Family & Cargo', 'More'];

  // Single-select group — only for swap items (you can't fit two saddles / two forks)
  function gearGroupOf(s) {
    s = (s || '').toLowerCase();
    if (/saddle|seat-?post/.test(s)) return 'saddle';
    if (/fork|suspension/.test(s)) return 'fork';
    if (/headlight/.test(s)) return 'headlight';
    if (/torque/.test(s)) return 'torque';
    if (/fender|rack/.test(s)) return 'fender';
    return '';
  }

  (function buildGrid() {
    var gearWrap = container.querySelector('[data-bc-gear]');
    var track = container.querySelector('[data-bc-gear-track]');
    var chipsWrap = container.querySelector('[data-bc-gear-chips]');
    if (!gearWrap || !track) return;

    function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

    var seen = {};
    var items = [];
    function ingest(nodeList, isSwap) {
      nodeList.forEach(function (el) {
        var id = el.getAttribute('data-variant');
        if (!id || seen[id]) return;     // swaps ingested first → take precedence over accessory dupes
        seen[id] = true;
        var img = el.getAttribute('data-img') || '';
        if (img && img.indexOf('{width}') > -1) img = img.replace('{width}', '300');
        var title = el.getAttribute('data-title') || '';
        var handle = el.getAttribute('data-handle') || '';
        // Short label for the "In your build" recap (drop the vendor prefix)
        gearTitles[id] = esc(title.replace(/^cyrusher\s+/i, ''));
        if (isSwap) swapIds[id] = true;
        items.push({
          id: id,
          title: title,
          url: el.getAttribute('data-url') || ('/products/' + handle),
          price: el.getAttribute('data-price') || '',
          cents: el.getAttribute('data-price-cents') || '0',
          compare: el.getAttribute('data-compare') || '',
          img: img,
          cat: gearCategoryOf(title + ' ' + handle),
          group: isSwap ? gearGroupOf(title + ' ' + handle) : '',
          isSwap: isSwap
        });
      });
    }
    ingest(container.querySelectorAll('.bc-swap-data__item'), true);
    ingest(document.querySelectorAll('.bc-cu-data__item'), false);

    if (!items.length) { container.style.display = 'none'; return; }

    // Essentials = first ACCESSORY in each near-universal category → "Most added" + Gear-up bundle
    var ESSENTIAL_CATS = ['Helmets', 'Locks & Security', 'Lights & Visibility'];
    var essentialPicks = [];
    ESSENTIAL_CATS.forEach(function (c) {
      var pick = items.filter(function (it) { return it.cat === c && !it.isSwap; })[0];
      if (pick) { pick.essential = true; essentialPicks.push(pick); }
    });

    // Order: essentials first, then by category (swaps before accessories within a category)
    var catIndex = {};
    GEAR_CAT_ORDER.forEach(function (c, i) { catIndex[c] = i; });
    items.sort(function (a, b) {
      if (a.essential && !b.essential) return -1;
      if (b.essential && !a.essential) return 1;
      if (a.essential && b.essential) return ESSENTIAL_CATS.indexOf(a.cat) - ESSENTIAL_CATS.indexOf(b.cat);
      var d = (catIndex[a.cat] == null ? 99 : catIndex[a.cat]) - (catIndex[b.cat] == null ? 99 : catIndex[b.cat]);
      if (d) return d;
      return (b.isSwap ? 1 : 0) - (a.isSwap ? 1 : 0);
    });

    var catsPresent = {};
    var cards = items.map(function (it, i) {
      catsPresent[it.cat] = true;
      var imgHtml = it.img
        ? '<img class="bcg-card__img" src="' + it.img + '" alt="' + it.title.replace(/"/g, '&quot;') + '" loading="lazy">'
        : '<div class="bcg-card__img bcg-card__img--ph"></div>';
      var cmpHtml = it.compare ? '<span class="bcg-card__compare">' + it.compare + '</span>' : '';
      var badge = it.essential ? '<span class="bcg-badge">Most added</span>' : '';
      return '<div class="bcg-card" data-variant="' + it.id + '" data-cat="' + it.cat + '" data-group="' + it.group + '" data-idx="' + i + '">' +
          badge +
          '<a class="bcg-card__imglink" href="' + it.url + '" target="_blank" rel="noopener">' + imgHtml + '</a>' +
          '<a class="bcg-card__title" href="' + it.url + '" target="_blank" rel="noopener">' + it.title + '</a>' +
          '<div class="bcg-card__price">' + cmpHtml + '<span class="bcg-card__now">' + it.price + '</span></div>' +
          '<button type="button" class="bcg-card__add" data-variant="' + it.id + '" data-price-cents="' + it.cents + '">+ Add</button>' +
        '</div>';
    }).join('');

    track.innerHTML = cards;
    gearWrap.hidden = false;

    // ── Desktop scroll arrows ────────────────────────────────────────────
    // Mouse users can't swipe a horizontal track; give them prev/next buttons.
    // (Hidden on mobile via CSS — touch scrolling works there.)
    var trackWrap = document.createElement('div');
    trackWrap.className = 'belcopia-upgrades__track-wrap';
    track.parentNode.insertBefore(trackWrap, track);
    trackWrap.appendChild(track);
    var navPrev = document.createElement('button');
    navPrev.type = 'button'; navPrev.className = 'bcg-nav bcg-nav--prev';
    navPrev.setAttribute('aria-label', 'Scroll add-ons left'); navPrev.innerHTML = '&#8249;';
    var navNext = document.createElement('button');
    navNext.type = 'button'; navNext.className = 'bcg-nav bcg-nav--next';
    navNext.setAttribute('aria-label', 'Scroll add-ons right'); navNext.innerHTML = '&#8250;';
    trackWrap.appendChild(navPrev); trackWrap.appendChild(navNext);
    function updateNav() {
      var overflow = track.scrollWidth - track.clientWidth > 4;
      navPrev.hidden = navNext.hidden = !overflow;
      navPrev.disabled = track.scrollLeft <= 2;
      navNext.disabled = track.scrollLeft >= (track.scrollWidth - track.clientWidth - 2);
    }
    function pageScroll(dir) {
      track.scrollBy({ left: dir * Math.max(160, Math.round(track.clientWidth * 0.8)), behavior: 'smooth' });
    }
    navPrev.addEventListener('click', function () { pageScroll(-1); });
    navNext.addEventListener('click', function () { pageScroll(1); });
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    setTimeout(updateNav, 300);   // re-check once card images have loaded

    // Horizontal scroller (one row, swipe through all). Chips filter; no cap / no "See all".
    var gridCat = '*';
    function applyGridView() {
      track.querySelectorAll('.bcg-card').forEach(function (card) {
        card.style.display = (gridCat === '*' || card.getAttribute('data-cat') === gridCat) ? '' : 'none';
      });
      track.scrollLeft = 0;   // snap back to start on filter change
      updateNav();
    }

    // Category chips (only when more than one category is present)
    var present = GEAR_CAT_ORDER.filter(function (c) { return catsPresent[c]; });
    if (chipsWrap && present.length > 1) {
      chipsWrap.innerHTML =
        '<button type="button" class="bcg-chip bcg-chip--active" data-cat="*">All</button>' +
        present.map(function (c) { return '<button type="button" class="bcg-chip" data-cat="' + c + '">' + c + '</button>'; }).join('');
      chipsWrap.addEventListener('click', function (e) {
        var chip = e.target.closest('.bcg-chip');
        if (!chip) return;
        gridCat = chip.getAttribute('data-cat');
        chipsWrap.querySelectorAll('.bcg-chip').forEach(function (c) { c.classList.toggle('bcg-chip--active', c === chip); });
        applyGridView();
      });
    } else if (chipsWrap) {
      chipsWrap.style.display = 'none';
    }
    applyGridView();

    // ── Collapse the à-la-carte grid behind a toggle ─────────────────────
    // Bundles (Bundle & Save) are the hero; individual extras are opt-in so the
    // section doesn't read as two competing carousels.
    gearWrap.classList.add('is-collapsed');
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'bcg-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = '<span class="bcg-toggle__txt">+ Add individual extras</span><span class="bcg-toggle__car">▸</span>';
    gearWrap.parentNode.insertBefore(toggle, gearWrap);
    toggle.addEventListener('click', function () {
      var open = gearWrap.classList.toggle('is-collapsed') === false;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.querySelector('.bcg-toggle__txt').textContent = open ? '− Hide individual extras' : '+ Add individual extras';
      toggle.querySelector('.bcg-toggle__car').textContent = open ? '▾' : '▸';
      if (open) updateNav();
    });

    // One-tap "Gear up" bundle — suppressed when real kit bundles exist (they replace it)
    var _kitBox = container.querySelector('[data-bc-kit]');
    var hasKit = !!(_kitBox && (_kitBox.getAttribute('data-kit-handles') || '').trim())
      || !!container.querySelector('.bc-kit-data__item');
    if (!hasKit && essentialPicks.length >= 2) {
      var sum = essentialPicks.reduce(function (t, p) { return t + (parseInt(p.cents || '0', 10) || 0); }, 0);
      var ESS_LABEL = { 'Helmets': 'Helmet', 'Locks & Security': 'Lock', 'Lights & Visibility': 'Lights' };
      var names = essentialPicks.map(function (p) { return ESS_LABEL[p.cat] || (p.title || '').replace(/^cyrusher\s+/i, ''); }).join(' + ');
      var bundle = document.createElement('div');
      bundle.className = 'bcg-bundle';
      bundle.innerHTML =
        '<div class="bcg-bundle__info"><span class="bcg-bundle__label">Gear up — add the essentials</span>' +
        '<span class="bcg-bundle__names">' + esc(names) + '</span></div>' +
        '<button type="button" class="bcg-bundle__btn" data-bc-bundle>Add all &middot; $' + (sum / 100).toFixed(2) + '</button>';
      trackWrap.parentNode.insertBefore(bundle, trackWrap);
      var bundleAddLabel = 'Add all · $' + (sum / 100).toFixed(2);
      bundle.querySelector('[data-bc-bundle]').addEventListener('click', function () {
        if (this.classList.contains('bcg-bundle__btn--done')) {
          // Toggle OFF — remove the essentials from the build
          essentialPicks.forEach(function (p) {
            delete gearSelected[p.id];
            setGearCardState(track.querySelector('.bcg-card[data-variant="' + p.id + '"] .bcg-card__add'), false);
          });
          this.textContent = bundleAddLabel;
          this.classList.remove('bcg-bundle__btn--done');
        } else {
          essentialPicks.forEach(function (p) {
            if (gearSelected[p.id]) return;
            gearSelected[p.id] = parseInt(p.cents || '0', 10) || 0;
            setGearCardState(track.querySelector('.bcg-card[data-variant="' + p.id + '"] .bcg-card__add'), true);
          });
          this.textContent = 'Essentials added ✓';
          this.classList.add('bcg-bundle__btn--done');
        }
        updateSubtotal();
      });
    }

    function deselect(btn) {
      delete gearSelected[btn.getAttribute('data-variant')];
      setGearCardState(btn, false);
    }

    // Toggle into / out of the build. Swap groups are single-select.
    track.addEventListener('click', function (e) {
      var btn = e.target.closest('.bcg-card__add');
      if (!btn) return;
      var card = btn.closest('.bcg-card');
      var id = btn.getAttribute('data-variant');
      if (!id) return;
      if (gearSelected[id]) {
        deselect(btn);
      } else {
        var group = card.getAttribute('data-group');
        if (group) {
          track.querySelectorAll('.bcg-card[data-group="' + group + '"] .bcg-card__add--done').forEach(deselect);
        }
        gearSelected[id] = parseInt(btn.getAttribute('data-price-cents') || '0', 10) || 0;
        setGearCardState(btn, true);
      }
      updateSubtotal();
    });
  })();

  // ── Starter Kit hero card (the "easy button") ────────────────────────
  // Built from the bc-cu-data block (no extra lookups). "Add the Kit" toggles
  // its items into the build (gearSelected) so they go to cart with the bike;
  // the 30%-off lands in-cart via the Cyrusher accessories automatic discount.
  (function buildKit() {
    var box = container.querySelector('[data-bc-kit]');
    if (!box) return;
    var handles = (box.getAttribute('data-kit-handles') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var label = box.getAttribute('data-kit-label') || 'Starter Kit';
    if (!handles.length) return;

    var byHandle = {};
    document.querySelectorAll('.bc-cu-data__item').forEach(function (el) { byHandle[el.getAttribute('data-handle')] = el; });

    var items = [];
    handles.forEach(function (h) {
      var el = byHandle[h];
      if (!el || !el.getAttribute('data-variant')) return;
      var img = el.getAttribute('data-img') || '';
      if (img.indexOf('{width}') > -1) img = img.replace('{width}', '200');
      items.push({
        id: el.getAttribute('data-variant'),
        title: el.getAttribute('data-title') || '',
        cents: parseInt(el.getAttribute('data-price-cents') || '0', 10) || 0,
        price: el.getAttribute('data-price') || '',
        url: el.getAttribute('data-url') || ('/products/' + h),
        img: img
      });
    });
    if (items.length < 2) { box.hidden = true; return; }

    var total = items.reduce(function (t, i) { return t + i.cents; }, 0);
    var disc = Math.round(total * 0.7);
    var save = total - disc;
    function esc2(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
    // Itemized "what's included" list — each item links to its product page so
    // customers can see exactly what's in the kit before adding.
    var rows = items.map(function (i) {
      var alt = (i.title || '').replace(/"/g, '&quot;');
      var thumb = i.img
        ? '<img class="bc-kit__ithumb" src="' + i.img + '" alt="' + alt + '" loading="lazy">'
        : '<span class="bc-kit__ithumb bc-kit__ithumb--ph"></span>';
      return '<li class="bc-kit__item">' +
          '<a class="bc-kit__ilink" href="' + i.url + '" target="_blank" rel="noopener">' + thumb + '</a>' +
          '<a class="bc-kit__iname" href="' + i.url + '" target="_blank" rel="noopener">' + esc2(i.title) + '</a>' +
          '<span class="bc-kit__iprice">' + i.price + '</span>' +
        '</li>';
    }).join('');

    box.innerHTML =
      '<div class="bc-kit__head"><span class="bc-kit__tag">Best value</span><span class="bc-kit__title">' + esc2(label) + '</span></div>' +
      '<p class="bc-kit__sub">What’s included — bundled at 30% off:</p>' +
      '<ul class="bc-kit__list">' + rows + '</ul>' +
      '<div class="bc-kit__foot">' +
      '  <div class="bc-kit__price"><span class="bc-kit__was">$' + (total / 100).toFixed(2) + '</span>' +
      '    <span class="bc-kit__now">$' + (disc / 100).toFixed(2) + '</span>' +
      '    <span class="bc-kit__save">Save $' + (save / 100).toFixed(2) + ' (30%)</span></div>' +
      '  <button type="button" class="bc-kit__btn" data-bc-kit-add>Add the Kit</button>' +
      '</div>' +
      '<p class="bc-kit__note">30% off applies in your cart when added with your bike.</p>';
    box.hidden = false;

    box.querySelector('[data-bc-kit-add]').addEventListener('click', function () {
      var btn = this;
      if (btn.classList.contains('bc-kit__btn--done')) {
        // Toggle OFF — people often add the kit just to see the price, then back out
        items.forEach(function (i) {
          delete gearSelected[i.id];
          setGearCardState(container.querySelector('.bcg-card[data-variant="' + i.id + '"] .bcg-card__add'), false);
        });
        btn.textContent = 'Add the Kit';
        btn.classList.remove('bc-kit__btn--done');
      } else {
        items.forEach(function (i) {
          if (gearSelected[i.id]) return;
          gearSelected[i.id] = i.cents;
          setGearCardState(container.querySelector('.bcg-card[data-variant="' + i.id + '"] .bcg-card__add'), true);
        });
        btn.textContent = 'Kit added ✓';
        btn.classList.add('bc-kit__btn--done');
      }
      updateSubtotal();
    });
  })();

  // ── Bundle & Save: real kit products (custom.kit_handles) ────────────
  // Renders the curated kit SKUs as cards above the à-la-carte grid. Single-select
  // (you buy one kit), and the chosen kit's variant bundles into the bike's Add to
  // Cart like any other selection. Each card links to the kit's own page for details.
  (function buildKits() {
    var wrap = container.querySelector('[data-bc-kits]');
    var track = container.querySelector('[data-bc-kits-track]');
    if (!wrap || !track) return;
    function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
    var items = [];
    container.querySelectorAll('.bc-kit-data__item').forEach(function (el) {
      var id = el.getAttribute('data-variant'); if (!id) return;
      var img = el.getAttribute('data-img') || ''; if (img.indexOf('{width}') > -1) img = img.replace('{width}', '360');
      items.push({
        id: id, title: el.getAttribute('data-title') || '', url: el.getAttribute('data-url') || '#',
        price: el.getAttribute('data-price') || '', cents: parseInt(el.getAttribute('data-price-cents') || '0', 10) || 0,
        compare: el.getAttribute('data-compare') || '',
        compareCents: parseInt(el.getAttribute('data-compare-cents') || '0', 10) || 0, img: img
      });
    });
    if (!items.length) { wrap.hidden = true; return; }
    track.innerHTML = items.map(function (it) {
      var alt = (it.title || '').replace(/"/g, '&quot;');
      var thumb = it.img ? '<img class="bc-kitcard__img" src="' + it.img + '" alt="' + alt + '" loading="lazy">' : '<span class="bc-kitcard__img"></span>';
      var cmp = it.compare ? '<span class="bc-kitcard__compare">' + it.compare + '</span>' : '';
      var save = (it.compareCents > it.cents) ? '<span class="bc-kitcard__save">Save $' + Math.round((it.compareCents - it.cents) / 100) + '</span>' : '';
      return '<div class="bc-kitcard" data-variant="' + it.id + '">' +
          '<span class="bc-kitcard__tag">Best value</span>' +
          '<a class="bc-kitcard__imglink" href="' + it.url + '" target="_blank" rel="noopener">' + thumb + '</a>' +
          '<a class="bc-kitcard__title" href="' + it.url + '" target="_blank" rel="noopener">' + esc(it.title) + '</a>' +
          '<div class="bc-kitcard__price">' + cmp + '<span class="bc-kitcard__now">' + it.price + '</span>' + save + '</div>' +
          '<a class="bc-kitcard__view" href="' + it.url + '" target="_blank" rel="noopener">See what’s included →</a>' +
          '<button type="button" class="bc-kitcard__add" data-variant="' + it.id + '" data-price-cents="' + it.cents + '">Add Kit</button>' +
        '</div>';
    }).join('');
    wrap.hidden = false;
    items.forEach(function (it) { gearTitles[it.id] = esc(it.title.replace(/^cyrusher\s+/i, '')); });
    function setKit(card, on) {
      card.classList.toggle('bc-kitcard--selected', on);
      var b = card.querySelector('.bc-kitcard__add');
      if (b) b.textContent = on ? 'Added ✓' : 'Add Kit';
    }
    track.addEventListener('click', function (e) {
      var btn = e.target.closest('.bc-kitcard__add'); if (!btn) return;
      var card = btn.closest('.bc-kitcard'); var id = btn.getAttribute('data-variant'); if (!id) return;
      if (gearSelected[id]) {
        delete gearSelected[id]; setKit(card, false);
      } else {
        // single-select among kits — pick one bundle
        track.querySelectorAll('.bc-kitcard').forEach(function (c) {
          var cid = c.getAttribute('data-variant');
          if (gearSelected[cid]) { delete gearSelected[cid]; setKit(c, false); }
        });
        gearSelected[id] = parseInt(btn.getAttribute('data-price-cents') || '0', 10) || 0;
        setKit(card, true);
      }
      updateSubtotal();
    });
  })();
})();

